<template lang="pug">
main(v-if="Show")
  parallax-inview
    animation-fade-in-up
      .page-top-image
        .image
          img(src="../assets/image09.jpg")
        .text
          h1.title Access
            span.title-caption アクセス
  parallax-inview
    animation-fade-in-up
      .page-description
        p 道に迷われた際はお電話ください。シャンプーセレクションへのご来店を心よりお待ちしております。

  parallax-inview
    animation-fade-in-up
      section.section
        p 〒111-0043<br>住所：東京都台東区駒形2-3-5 １F
        p 営業時間：10:00～21:00
        p
          a(href="tel:03-6802-8828") TEL：03-6802-8828
        p 定休日：毎週月曜日

  parallax-inview
    animation-fade-in-up
      section.section
        .map-image
          img(src='../assets/map.png')
        button.button.is-default(@click="ToGoogleMap()") Google Mapで確認する

  parallax-inview
    animation-fade-in-up
      section.section
        h2.title 電車でのアクセス
        ul
          li ・都営大江戸線 蔵前駅・・・徒歩2分
          li ・都営浅草線 蔵前駅・・・徒歩3分
</template>

<script>
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室 | Access',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd'],
  components: {
    ParallaxInview,
    AnimationFadeInUp
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    }
  },
  methods: {
    ToGoogleMap: function() {
      window.open('https://goo.gl/maps/ALmFRXTprP5ffMqN7')
    }
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding-left: 8px;
  padding-right: 8px;
}

.map-image {
  margin: 0 40px 20px;
  img {
    width: 100%;
  }
}

.button.is-default {
  padding: 18px 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/Access.vue